import React, {Component} from 'react';
import {withFirebase} from '../../components/Firebase';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
import {compose} from 'recompose';
import Loading from '../../components/Base/Loading'
import Layout from '../../components/Layout'
import PostDetails from '../../pages/PostDetails'
import {postActions, postSelectors} from "../../store/posts";

/* Container for My Posts page */

class PostDetailsContainer extends Component {
	constructor(props) {
		super(props);
		this.id = this.props.match.params.post;
		this.state = {
			width: 0,
			height: 0,
			loading: false,
			post: {},
			faculty: []
		}
	}


	componentDidMount() {
		// console.log('post details', this.uid)
		//console.log(this.props)
		const {post} = this.props;
		if(post === undefined){
			this.setState({loading: true});

		}
		/** 
		this.listener = this.props.firebase.post(this.id).onSnapshot(snapshot => {
			let data = {id: snapshot.id, ...snapshot.data()}
			updateDetails(data)
			this.setState({post: data, loading: false})

		} )
		*/
		//this.fetchFacultyList()

	}

	fetchFacultyList = async () => {
		try {
			let faculty = [];
			let facultyRef = await this.props.firebase.faculties().get();
			facultyRef.docs.forEach(doc => faculty.push({id: doc.id, ...doc.data()}));
			this.setState({faculty, loading: false})
		} catch (error) {
			//console.log(error)
		}
	};

	componentWillUnmount() {
		this.listener && this.listener()
	}

	render() {
		const { loading, faculty} = this.state;
		const {profile, post} = this.props;
		let isLoading = false
		if(loading || profile === null || profile === undefined){
			isLoading = true
		}
		if(!post){
			isLoading = true
		}



		return (
			<Layout {...this.props} noSideBar postTitle>
				{isLoading ? <Loading/> :
					<PostDetails {...this.props} faculty={faculty} post={post} loading={loading}/>}
			</Layout>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	loading: postSelectors.isLoading(state.posts),
	posts: postSelectors.refreshList(state.posts),
	pinned: postSelectors.refreshPinned(state.posts),
	post: postSelectors.refreshPostWithId(state.posts, ownProps.match.params.post)

});

const mapDispatchToProps = (dispatch) => ({
	updateList: (data) => dispatch(postActions.updateList(data)),
	updateDetails: (data) => dispatch(postActions.updateDetails(data))
})



export default compose(withRouter, withFirebase, connect(mapStateToProps, mapDispatchToProps))(PostDetailsContainer);
